import {
  getBaseField,
  getNestedValue,
  objectLabel,
} from "./valueUtils";

export function getArrayItems(row, column, rawValue) {
  const baseField = getBaseField(column.field);
  const baseValue = row?.[baseField];

  if (Array.isArray(baseValue)) return baseValue;
  if (Array.isArray(rawValue)) return rawValue;

  if (baseValue && typeof baseValue === "object") return [baseValue];

  if (baseValue !== null && baseValue !== undefined && baseValue !== "") {
    return [baseValue];
  }

  if (rawValue !== null && rawValue !== undefined && rawValue !== "") {
    return [rawValue];
  }

  return [];
}

export function getArrayChipLabel(item, column) {
  if (item === null || item === undefined || item === "") return "—";

  if (typeof item === "object") {
    const nestedPath = String(column.field || "")
      .split(".")
      .slice(1)
      .join(".");

    return (
      getNestedValue(item, nestedPath) ||
      objectLabel(item, column) ||
      item.name ||
      item.label ||
      item.title ||
      item.value ||
      "—"
    );
  }

  return String(item);
}

function normalizeComparable(value) {
  if (value === null || value === undefined) return "";

  if (typeof value === "object") {
    return String(value._id || value.id || value.userId || value.value || "")
      .trim()
      .toLowerCase();
  }

  return String(value).trim().toLowerCase();
}

export function extractApiArray(payload) {
  const candidates = [
    payload?.data?.data,
    payload?.data?.users,
    payload?.data?.result,
    payload?.data?.results,
    payload?.data,
    payload?.users,
    payload?.result,
    payload?.results,
    payload,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) return candidate;
  }

  return [];
}

function getItemMatchingKeys(item, column = {}) {
  const nestedPath = String(column.field || "")
    .split(".")
    .slice(1)
    .join(".");

  if (item && typeof item === "object") {
    return [
      item._id,
      item.id,
      item.userId,
      item.value,
      item.name,
      item.emailId,
      item.email,
      column.apiTitle ? item[column.apiTitle] : "",
      nestedPath ? getNestedValue(item, nestedPath) : "",
    ]
      .map(normalizeComparable)
      .filter(Boolean);
  }

  return [normalizeComparable(item)].filter(Boolean);
}

function getRecordMatchingKeys(record, column = {}) {
  if (!record || typeof record !== "object") return [];

  return [
    record._id,
    record.id,
    record.userId,
    record.value,
    record.name,
    record.emailId,
    record.email,
    column.apiTitle ? record[column.apiTitle] : "",
  ]
    .map(normalizeComparable)
    .filter(Boolean);
}

function findApiRecordForItem(item, apiRows = [], column = {}) {
  const itemKeys = getItemMatchingKeys(item, column);

  if (!itemKeys.length || !Array.isArray(apiRows) || !apiRows.length) {
    return null;
  }

  return (
    apiRows.find((record) => {
      const recordKeys = getRecordMatchingKeys(record, column);
      return recordKeys.some((recordKey) => itemKeys.includes(recordKey));
    }) || null
  );
}

export function buildDetailSource(item, apiRows = [], column = {}) {
  const apiRecord = findApiRecordForItem(item, apiRows, column);

  if (apiRecord && item && typeof item === "object") {
    return {
      ...apiRecord,
      ...item,
    };
  }

  if (apiRecord) return apiRecord;
  if (item && typeof item === "object") return item;

  return null;
}
